import DealSales from "../../views/modules/sales/deals/DealSales.vue";
import DealFormView from "../../views/modules/sales/deals/DealFormView";
import CustomersList from "../../components/customers/CustomersList";
import DocumentList from "../../views/modules/sales/documents/DocumentList";
//import StatisticList from "../../views/modules/sales/statistics/StatisticList";
import SalesConfig from "../../views/modules/sales/config/SalesConfig";
import ProspectsSales from "@/views/modules/sales/prospects/ProspectsSales.vue";
import KPI from "../../views/modules/sales/kpi/KPI";
import roles from "@/roles";
import layouts from "../../layout";
import training from "../../views/modules/sales/training/mview/index";
import channelMview from "../../views/modules/sales/training/mview/channelMview.vue";

import kpiSales from "../../views/modules/sales/kpi/KPIventas.vue";
// import store from "@/store";
// import { COMPANYS } from "@/const";
import CollectionList from "../../views/modules/finances/collections/CollectionList";
//import trainignMview from "../../views/modules/sales/training/Mview";
import TableGoalsVendorns from "@/views/modules/sales/reports/TableGoalsVendorns.vue";

export default {
  path: "/sales",
  name: "sales",
  component: () =>
    import(/* webpackChunkName: "Sales" */ "@/views/modules/sales/Sales.vue"),
  redirect: {
    name: "sales-deals"
  },
  meta: {
    auth: true,
    title: "Sales",
    roles: [
      roles.SoporteVentas,
      roles.EjecutivoDeVentas,
      roles.CEO,
      roles.SuperUsuario
    ]
  },
  children: [
    {
      path: "deals",
      name: "sales-deals",
      component: DealSales,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Sales Deals",
        tags: ["sales", "deals"],
        review: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      redirect: {
        name: "sales-deals-list"
      },
      children: [
        {
          path: "",
          alias: "/",
          name: "sales-deals-list",
          component: () => import("@/views/modules/sales/deals/index.vue"),
          props: {
            phase: "Nueva"
          },
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Deals List",
            title_i18n: "sales.breadcrumb.sales-deals-list",
            tags: ["sales", "deals", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "create",
          props: {
            ClientCode: {
              type: String,
              required: false
            }
          },
          name: "sales-deals-create",
          component: () =>
            import(
              /* webpackChunkName: "NewDeals" */ "../../views/modules/sales/deals/NewDeals.vue"
            ),
          meta: {
            auth: true,
            searchable: false,
            layout: layouts.navLeft,
            title: "Sales Deals Create",
            tags: ["sales", "deals", "create"],
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: ":id",
          name: "sales-deals-view",
          component: DealFormView,
          meta: {
            auth: true,
            searchable: false,
            layout: layouts.navLeft,
            title: "Sales Deals",
            tags: ["sales", "deals"],
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
      ]
    },

    {
      path: "prospects",
      name: "sales-prospects",
      component: ProspectsSales,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Sales Prospects",
        tags: ["sales", "prospects"],
        review: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      redirect: {
        name: "sales-prospects-list"
      },
      children: [
        {
          path: "",
          alias: "/",
          name: "sales-prospects-list",
          component: () =>
            import(
              /* webpackChunkName: "ProspectList" */ "@/components/prospects/ProspectList.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Prospects List",
            tags: ["sales", "prospects", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "create",
          name: "sales-prospects-create",
          component: () =>
            import("../../views/modules/sales/prospects/ProspectCreate.vue"),
          meta: {
            auth: true,
            searchable: false,
            layout: layouts.navLeft,
            title: "Sales Prospect Create",
            tags: ["sales", "prospect", "create"],
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
      ]
    },
    /* {
      path: "collections",
      name: "sales-collection",
      component: CollectionList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Collections",
        tags: ["finances", "collection"],
        index: true
      }
    },*/

    {
      path: "customers",
      name: "sales-customers",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Sales Customers",
        tags: ["sales", "customer"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "customers",
          name: "sales-customers",
          component: CustomersList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Customers",
            tags: ["sales", "customer"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-sla-per-Customers",
          name: "sales-kpi-sla-per-Customers-in-customers",
          component: () =>
            import("@/views/modules/sales/kpi/SLAPorClienteKPI.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI SLA Por Clientes",
            tags: ["sales", "deals", "list", "SLA", "kpi", "customers"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-satisfaction-per-Customers",
          name: "sales-kpi-satisfaction-per-Customers-in-customers",
          component: () =>
            import("@/views/modules/sales/kpi/SatisfaccionPorClientesKPI"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Satisfaccion Por Clientes",
            tags: [
              "sales",
              "deals",
              "list",
              "satisfaction",
              "kpi",
              "customers"
            ],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
      ]
    },
    {
      path: "documents",
      name: "sales-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["sales", "documents"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      }
    },
    /*{
      path: "statistics",
      name: "sales-statistic",
      component: StatisticList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Statistic",
        tags: ["sales", "statistic"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      }
    },*/

    /*{
      path: "report",
      name: "report",
      component: KPI,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "REPORTES",
        tags: ["sales", "report"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "report-per-sales",
          name: "report-sales-per-vendor",
          component: () =>
            import("../../views/modules/sales/reports/ReportSales"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "REPORTE DE VENTAS",
            tags: ["report", "sales", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
        /*
        {
          path: "report-devices",
          name: "report-devices-by-client",
          component: () =>
            import("../../views/modules/sales/reports/ReportDevicesByClients"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte Equipos Por Cliente",
            tags: ["report", "sales", "list", "devices"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }

      ]
    },*/
    {
      path: "kpi",
      name: "kpi",
      component: KPI,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["sales", "kpi"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        // {
        //   path: "kpi-per-sales",
        //   name: "sales-kpi-per-sales",
        //   component: () => import("../../views/modules/sales/kpi/DealsKpi"),
        //   meta: {
        //     auth: true,
        //     searchable: true,
        //     layout: layouts.navLeft,
        //     title: "KPI VENTAS",
        //     tags: ["sales", "deals", "list"],
        //     index: true,
        //     roles: [
        //       roles.SoporteVentas,
        //       roles.EjecutivoDeVentas,
        //       roles.CEO,
        //       roles.SuperUsuario
        //     ]
        //   }
        // },
        {
          path: "report-per-sales",
          name: "report-sales-per-vendor",
          component: () =>
            import("../../views/modules/sales/reports/ReportSales"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "REPORTE DE VENTAS",
            tags: ["report", "sales", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        // {
        //   path: "kpi-sales",
        //   name: "sales-kpi-sales",
        //   component: () =>
        //     import("../../views/modules/sales/kpi/KPIventas.vue"),
        //   meta: {
        //     auth: true,
        //     searchable: true,
        //     layout: layouts.navLeft,
        //     title: "KPI de Ventas",
        //     tags: ["sales", "deals", "list"],
        //     index: true,
        //     roles: [
        //       roles.SoporteVentas,
        //       roles.EjecutivoDeVentas,
        //       roles.CEO,
        //       roles.SuperUsuario
        //     ]
        //   }
        // },
        {
          path: "ClientWithoutCalling",
          name: "sales-kpi-missingCalling",
          component: () =>
            import(
              "../../views/modules/sales/kpi/ClientWithoutCallingSales.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Clientes sin llamar",
            tags: ["sales", "deals", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "ContactWithoutCalling",
          name: "sales-kpi-missingCalling-Contact",
          component: () =>
            import("../../views/modules/sales/kpi/ContactWithoutCallingSales"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Contactos sin llamar",
            tags: ["sales", "deals", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-per-quotes-delivered",
          name: "sales-kpi-per-quotes-delivered",
          component: () =>
            import("../../views/modules/sales/kpi/DealsQuotesDdeliveredKpi"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Quotes Delivered KPI",
            tags: ["sales", "deals", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-sla-per-Customers",
          name: "sales-kpi-sla-per-Customers",
          component: () =>
            import("@/views/modules/sales/kpi/SLAPorClienteKPI.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI SLA Por Clientes",
            tags: ["sales", "deals", "list", "SLA", "kpi", "customers"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-satisfaction-per-Customers",
          name: "sales-kpi-per-Customers",
          component: () =>
            import("@/views/modules/sales/kpi/SatisfaccionPorClientesKPI"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Satisfaccion Por Clientes",
            tags: [
              "sales",
              "deals",
              "list",
              "satisfaction",
              "kpi",
              "customers"
            ],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "collections",
          name: "sales-collection",
          component: CollectionList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Collections",
            tags: ["finances", "collection"],
            index: true
          }
        }
      ]
    },
    {
      path: "kpi-sales",
      name: "kpi.sales-kpi-sales",
      component: kpiSales,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI de Ventas",
        tags: ["sales", "deals", "list"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      }
    },
    {
      path: "training",
      name: "training",
      component: training,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Entrenamientos",
        tags: ["training"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "training-magytrack",
          name: "training-traning-magytrack",
          component: () =>
            import("../../views/modules/sales/training/magytrack/Magytrack"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "magytrack",
            tags: ["sales", "training", "magytrack"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
            //disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
          },
          children: [
            {
              path: "user-manual",
              name: "training-user-manual",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/userManualMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["sales", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "link-channel-magytrack",
              name: "training-link-channel-magytrack",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/channelMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["sales", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "mview-magytrack",
              name: "training-magytrack-contract",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/contractMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["sales", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "test-magytrack",
              name: "training-test-magytrack",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/testMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["sales", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "sales-presentation-magytrack",
              name: "training-sales-presentation-magytrack",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/presentationMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["sales", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "product-presentation-magytrack",
              name: "training-product-presentation-magytrack",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/presentationProductMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["sales", "training", "presentationProductmagytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "price-list-mview",
              name: "training-price-list-magytrack",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/priceListMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["sales", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "model-contract-mview",
              name: "training-model-contract-magytrack",
              component: () =>
                import(
                  "../../views/modules/sales/training/magytrack/contractMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["sales", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "training-mview",
          name: "training-traning-mview",
          component: () =>
            import("../../views/modules/sales/training/mview/Mview"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Mview",
            tags: ["sales", "training", "Mview"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
            // disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "user-manual-mview",
              name: "training-user-manual-mview",
              component: () =>
                import(
                  "../../views/modules/sales/training/mview/userManualMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["sales", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "link-channel-mview",
              name: "training-link-channel-mview",
              component: channelMview,
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["sales", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "mview-contract",
              name: "training-mview-contract",
              component: () =>
                import(
                  "../../views/modules/sales/training/mview/contractMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["sales", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "test-mview",
              name: "training-test-mview",
              component: () =>
                import("../../views/modules/sales/training/mview/testMview"),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["sales", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "sales-presentation-mview",
              name: "training-sales-presentation-mview",
              component: () =>
                import(
                  "../../views/modules/sales/training/mview/presentationMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["sales", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "product-presentation-mview",
              name: "training-product-presentation-mview",
              component: () =>
                import(
                  "../../views/modules/sales/training/mview/presentationProductMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["sales", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "price-list-mview",
              name: "training-price-list-mview",
              component: () =>
                import(
                  "../../views/modules/sales/training/mview/priceListMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["sales", "training", "priceListMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "model-contract-mview",
              name: "training-model-contract-mview",
              component: () =>
                import(
                  "../../views/modules/sales/training/mview/modelContractMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["sales", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "training-mpago",
          name: "training-mpago",
          component: () =>
            import("../../views/modules/sales/training/magypago/Mpago"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Mpago",
            tags: ["sales", "training", "mpago"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
            //disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "training-user-manual-mpago",
              name: "training-user-manual-mpago",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/userManualMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["sales", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "link-channel-mpago",
              name: "training-link-channel-mpago",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/channelMpago.vue"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["sales", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "mpago-contract",
              name: "training-mpago-contract",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/contractMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["sales", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "mview-contract",
              name: "training-mpago-terminalManual",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["sales", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "test-mview",
              name: "training-test-mpago",
              component: () =>
                import("../../views/modules/sales/training/magypago/testMpago"),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["sales", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "sales-presentation-mpago",
              name: "training-sales-presentation-mpago",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/presentationMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["sales", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "product-presentation-mpago",
              name: "training-product-presentation-mpago",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/presentationProductMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["sales", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "price-list-mpago",
              name: "training-price-list-mpago",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/priceListMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["sales", "training", "priceListMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "model-contract-mpago",
              name: "training-model-contract-mpago",
              component: () =>
                import(
                  "../../views/modules/sales/training/magypago/modelContractMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["sales", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "training-magyloterry",
          name: "training-magyloterry",
          component: () =>
            import(
              "../../views/modules/sales/training/magyloterry/magyloterry"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Magyloterry",
            tags: ["sales", "training", "magylottery"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
            //disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "user-manual-Lottery",
              name: "training-user-manual-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/userManualLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["sales", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "link-channel-loterry",
              name: "training-link-channel-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/channelLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["sales", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "mview-contract",
              name: "training-Lottery-contract",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/contractLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["sales", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "mview-contract",
              name: "training-Lottery-terminalManual",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["sales", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "test-mview",
              name: "training-test-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/testLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["sales", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "sales-presentation-Lottery",
              name: "training-sales-presentation-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/presentationLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["sales", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "product-presentation-Lottery",
              name: "training-product-presentation-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/presentationProductLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["sales", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "price-list-Lottery",
              name: "training-price-list-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/priceListLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["sales", "training", "priceListLottery"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "model-contract-Lottery",
              name: "training-model-contract-Lottery",
              component: () =>
                import(
                  "../../views/modules/sales/training/magyloterry/modelContractLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["sales", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "training-seahourse",
          name: "training-seahourse",
          component: () =>
            import("../../views/modules/sales/training/seahourse/seahourse"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Seahourse",
            tags: ["sales", "SEAHORSE", "training"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
            //disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "user-manual-seahourse",
              name: "training-user-manual-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/userManualseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["sales", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "link-channel-seahourse",
              name: "training-link-channel-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/channelseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["sales", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "seahourse-contract",
              name: "training-seahourse-contract",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/contractseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["sales", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "seahourse-contract",
              name: "training-seahourse-terminalManual",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["sales", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "test-seahourse",
              name: "training-test-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/testseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["sales", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "sales-presentation-seahourse",
              name: "training-sales-presentation-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/presentationseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["sales", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "product-presentation-seahourse",
              name: "training-product-presentation-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/presentationProductseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: ["sales", "training", "presentationProductMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "price-list-seahourse",
              name: "training-price-list-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/priceListseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["sales", "training", "priceListLottery"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "model-contract-seahourse",
              name: "training-model-contract-seahourse",
              component: () =>
                import(
                  "../../views/modules/sales/training/seahourse/modelContractseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["sales", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        }
        // {
        //   path: "kpi-per-quotes-delivered",
        //   name: "sales-kpi-per-quotes-delivered",
        //   component: () =>
        //     import("../../views/modules/sales/kpi/DealsQuotesDdeliveredKpi"),
        //   meta: {
        //     auth: true,
        //     searchable: true,
        //     layout: layouts.navLeft,
        //     title: "Quotes Delivered KPI",
        //     tags: ["sales", "deals", "list"],
        //     index: true,
        //     roles: [
        //       roles.SoporteVentas,
        //       roles.EjecutivoDeVentas,
        //       roles.CEO,
        //       roles.SuperUsuario
        //     ]
        //   }
        // }
      ]
    },
    {
      path: "config",
      name: "sales-config",
      component: SalesConfig,
      meta: {
        auth: true,
        searchable: false,
        layout: layouts.navLeft,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "goals-per-seller-1",
          name: "sales-config-goals-per-seller-1",
          component: TableGoalsVendorns,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Config Goals Per Product",
            tags: ["sales", "deals", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "goals-per-seller-2",
          name: "sales-config-goals-per-seller-2",
          component: () =>
            import("../../views/modules/sales/config/GoalsPerSeller"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Config Goals Per Product",
            tags: ["sales", "deals", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "deals-type",
          name: "sales-config-deals-type",
          component: () => import("../../views/modules/sales/config/DealsType"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Config Deals Type",
            tags: ["sales", "deals_type", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "deals-fase",
          name: "sales-config-deals-fase",
          component: () => import("../../views/modules/sales/config/DealsFase"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Config Deals Fase",
            tags: ["sales", "deals_fase", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "coins",
          name: "sales-config-coins",
          component: () => import("../../views/modules/sales/config/Coins"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Config Coins",
            tags: ["sales", "coins", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "activity-conditions",
          name: "sales-config-activity-conditions",
          component: () =>
            import(
              "../../views/modules/sales/config/activities/ActivityConditions"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Sales Config Activity Conditions",
            tags: ["sales", "activity_conditions", "list"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "prospect-assingment",
          name: "sales-config-prospect-assignment",
          component: () =>
            import("@/views/modules/sales/config/ProspectAssignment.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Prospect Assignment",
            index: true,
            roles: [
              roles.CEO,
              roles.SuperUsuario,
              roles.SupervisorDeVentas,
              roles.SupervisorDeSoporteDeVentas,
              roles.SoporteVentas
            ]
          }
        }
      ]
    },
    {
      path: "reportsurvey",
      name: "employeesSales-reportsurvey",
      component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Respuesta de Empleados",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    }
    // {
    //   path: "config",
    //   name: "sales-config",
    //   component: KPIVentas,
    //   meta: {
    //     auth: true,
    //     searchable: false,
    //     layout: layouts.navLeft,
    //     roles: [
    //       roles.SoporteVentas,
    //       roles.EjecutivoDeVentas,
    //       roles.CEO,
    //       roles.SuperUsuario
    //     ]
    //   }
    //   // children: [
    //   //   {
    //   //     path: "goals-per-seller",
    //   //     name: "sales-config-goals-per-seller",
    //   //     component: () =>
    //   //       import("../../views/modules/sales/config/GoalsPerSeller"),
    //   //     meta: {
    //   //       auth: true,
    //   //       searchable: true,
    //   //       layout: layouts.navLeft,
    //   //       title: "Sales Config Goals Per Product",
    //   //       tags: ["sales", "deals", "list"],
    //   //       index: true,
    //   //       roles: [
    //   //         roles.SoporteVentas,
    //   //         roles.EjecutivoDeVentas,
    //   //         roles.CEO,
    //   //         roles.SuperUsuario
    //   //       ]
    //   //     }
    //   //   },
    //   // {
    //   //   path: "activity-conditions",
    //   //   name: "sales-config-activity-conditions",
    //   //   component: () =>
    //   //     import(
    //   //       "../../views/modules/sales/config/activities/ActivityConditions"
    //   //     ),
    //   //   meta: {
    //   //     auth: true,
    //   //     searchable: true,
    //   //     layout: layouts.navLeft,
    //   //     title: "Sales Config Activity Conditions",
    //   //     tags: ["sales", "activity_conditions", "list"],
    //   //     index: true,
    //   //     roles: [
    //   //       roles.SoporteVentas,
    //   //       roles.EjecutivoDeVentas,
    //   //       roles.CEO,
    //   //       roles.SuperUsuario
    //   //     ]
    //   //   }
    //   // }
    //   //]
    // }
  ]
};
